import React from 'react';
import {useTranslation} from 'react-i18next';

interface AgentTabLoadingProps {
  active: boolean;
  className?: string;
}

const AgentTabLoading = ({active, className = ''}: AgentTabLoadingProps) => {
  const {t} = useTranslation();

  if (!active) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        'pointer-events-none absolute inset-0 z-10 flex items-center justify-center',
        className,
      ]
        .filter(Boolean)
        .join(' ')}>
      <span className="h-8 w-8 animate-spin rounded-full border-[0.1875rem] border-[#FFE8A1]/70 border-t-[#FB6B0B]" />
      <span className="sr-only">{t('loading')}</span>
    </div>
  );
};

export default AgentTabLoading;
